import { createFeatureSelector } from '@ngrx/store';
import {
  BOARDING_CERTIFICATE_COMMON_STORE_NAME,
  BoardingCertificateCommonState,
} from './boarding-certificate-common.state';

/** Select BoardingCertificateCommon State */
export const selectBoardingCertificateCommonState = createFeatureSelector<BoardingCertificateCommonState>(
  BOARDING_CERTIFICATE_COMMON_STORE_NAME
);
